<template>
<div class="chapter">
<div class="inner_page">
<h1>Acknowledgments</h1>
<p class="sectiontop">Due to circumstances beyond my control, there were times when it seemed that this book would never be published. If any single person was largely responsible for getting it into print, it was my agent and friend Scott Siegel. To him I am especially grateful.</p>
<p>Helping to fill in many of the blanks in this story, which so far has been ten years in development and still is not played out, was Larry Aylor, whose life was changed radically by the events described herein. There are others as well who helped me along the way, many in more ways than they realize. Among those to whom I owe special gratitude are Larry Mitchell and Peter Lesser, who gave generously of their time and expertise, and who provided me with priceless insight into a complicated situation. Also providing valuable material at times when I really needed it were Captain Morris McGowan and Glenna Whitley. To them, I am also indebted.</p>
<p>One tremendous personal benefit that resulted from researching this book was that I got the chance to renew old friendships among current and former journalists in Dallas and Paris, all of whom gave unselfishly of their insight and knowledge. My sincerest appreciation to Steve Reed, Travis Hughs, Paul Freeman, and Arthur Higbee.</p>
<p>Others to whom I owe special thanks for many services en route to the completion of this book include Judge Pat McDowell and his courtroom family—Pat, Ginny, Margie, and King—along with Scot Key, Donna Reed, Heidi Hizel, Rich Gibula, Diana Higbee, Linda Little, Jim Wieck, Nicole Perrier, Michael Byck, and C.C. Risenhoover. Thanks to you all.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_ack.vue?cfb03892